/* eslint-disable react/jsx-pascal-case */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import NewContentList from "./NewContentList";

import Event202104_contentList from './Event202104_contentList';

import '../../css/event20210317.css';

import { toast } from 'react-toastify'; //토스트(toast)
import moment from 'moment';

class Event202104_newContent extends Component {
  state = {
    eventCode: 0,
  };

  _goVod = (code) => {
    const { history, setEventIdx } = this.props;
    setEventIdx(0);
    if (code === '4' || code === '5') {
      history.push('/list?q=tag&c=' + code);
    } else {
      history.push('/list?q=genre&c=' + code);
    }
  };
  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };
  _pass = () => {
    const { history, setEventIdx } = this.props;
    setEventIdx(0);
    history.push('/ticket');
  };
  _timeTable = () => {
    const { setTimelineWeek } = this.props;
    const curDate = new Date();
    const today = moment(curDate).format('YYYY-MM-DD HH:mm:ss');

    if (today <= '2021-03-31 00:00:00') {
      toast.warn('3월 31일 이후 확인이 가능합니다.');
    } else {
      //alert(0)
      //setEventIdx(0)
      setTimelineWeek(true);
    }
  };
  render() {
    const bgImg = '/img/event/20210317/bg.png';
    const curDate = new Date();
    const today = moment(curDate).format('YYYY-MM-DD HH:mm:ss');
    const { imgUrl } = this.props;

    return (
      <Fragment>
        {today >= '2021-03-26 00:00:00' ? (
          <Fragment>
            <div
              className="detil_top"
              id="top"
              style={{
                background: 'url(' + bgImg + ') no-repeat top center',
                backgroundColor: '#000',
              }}
            >
              <div
                className="detail_layer_close"
                onClick={this._onClose}
                style={{ cursor: 'pointer', zIndex: 900 }}
              >
                <img src={imgUrl + '/img/detail_img/close_1.png'} />
              </div>
              <div className="event210317">
                <div className="sticky">
                  <div className="quick">
                    <a href="#top">
                      <img
                        src={imgUrl + '/img/event/20210317/quick01.png'}
                        alt="top"
                      />
                    </a>
                    <a href="#newList">
                      <img
                        src={imgUrl + '/img/event/20210317/quick02.png'}
                        alt="신작목록"
                      />
                    </a>
                    <a href="#gift">
                      <img
                        src={imgUrl + '/img/event/20210317/quick03.png'}
                        alt="경품"
                      />
                    </a>
                    <a href="#timetable">
                      <img
                        src={imgUrl + '/img/event/20210317/quick04.png'}
                        alt="관람수칙"
                      />
                    </a>
                    <a href="#comment">
                      <img
                        src={imgUrl + '/img/event/20210317/quick05.png'}
                        alt="요일별시간표"
                      />
                    </a>
                  </div>
                </div>
                <div className="main">
                  <div className="mission_wrap">
                    <div className="mission mission1">
                      <p className="txt_bubble">
                        <img
                          src={
                            imgUrl +
                            '/img/event/20210317/main_mission1_bubble.png'
                          }
                          alt="mission1 로맨틱시그널"
                        />
                      </p>
                      <button type="button">
                        <img
                          src={
                            imgUrl + '/img/event/20210317/main_mission1_btn.png'
                          }
                          alt="참여하러가기"
                          onClick={() => this._goVod('4')}
                        />
                      </button>
                      <img
                        src={imgUrl + '/img/event/20210317/main_mission1.png'}
                      />
                    </div>

                    <div className="mission mission2">
                      <p className="txt_bubble">
                        <img
                          src={
                            imgUrl +
                            '/img/event/20210317/main_mission2_bubble.png'
                          }
                          alt="mission2 SF스페이스"
                        />
                      </p>
                      <button type="button">
                        <img
                          src={
                            imgUrl + '/img/event/20210317/main_mission2_btn.png'
                          }
                          alt="참여하러가기"
                          onClick={() => this._goVod('C03')}
                        />
                      </button>
                      <img
                        src={
                          imgUrl + '/img/event/20210317/main_mission2_lock.png'
                        }
                      />
                    </div>

                    <div className="mission mission3">
                      <p className="txt_bubble">
                        <img
                          src={
                            imgUrl +
                            '/img/event/20210317/main_mission3_bubble.png'
                          }
                          alt="mission3 판타지"
                        />
                      </p>
                      <button type="button">
                        <img
                          src={
                            imgUrl + '/img/event/20210317/main_mission3_btn.png'
                          }
                          alt="참여하러가기"
                          onClick={() => this._goVod('C01')}
                        />
                      </button>
                      <img
                        src={
                          imgUrl + '/img/event/20210317/main_mission3_lock.png'
                        }
                      />
                    </div>

                    <div className="mission mission4">
                      <p className="txt_bubble">
                        <img
                          src={
                            imgUrl +
                            '/img/event/20210317/main_mission4_bubble.png'
                          }
                          alt="mission4 일상퍼레이드"
                        />
                      </p>
                      <button type="button">
                        <img
                          src={
                            imgUrl + '/img/event/20210317/main_mission4_btn.png'
                          }
                          alt="참여하러가기"
                          onClick={() => this._goVod('5')}
                        />
                      </button>
                      <img
                        src={
                          imgUrl + '/img/event/20210317/main_mission4_lock.png'
                        }
                      />
                    </div>

                    <div className="mission mission5">
                      <p className="txt_bubble">
                        <img
                          src={
                            imgUrl +
                            '/img/event/20210317/main_mission5_bubble.png'
                          }
                          alt="mission5 액션어드벤처"
                        />
                      </p>
                      <button type="button">
                        <a href="#comment">
                          <img
                            src={
                              imgUrl +
                              '/img/event/20210317/main_mission5_btn.png'
                            }
                            alt="참여하러가기"
                          />
                        </a>
                      </button>
                      <img
                        src={
                          imgUrl + '/img/event/20210317/main_mission5_lock.png'
                        }
                      />
                    </div>
                  </div>
                  <div className="main_visual">
                    <img src={imgUrl + '/img/event/20210317/main_bg.png'} />
                  </div>
                </div>
                <div className="gift_wrap" id="gift">
                  <h3 className="tit">
                    <img
                      src={imgUrl + '/img/event/20210317/gift_tit.png'}
                      alt="“애니플러스 2분기 신작 페스티벌! 신작 테마파크 렛츠 고~!”"
                    />
                    <p className="sub">
                      애니플러스 신작 MAP을 모두 오픈한 방문객에게 스페셜한
                      선물을 랜덤 증정!
                    </p>
                    <p className="date">
                      이벤트 기간 : 3/26 (금) ~ 3/30 (화) 당첨일 : 4/8 (목)
                    </p>
                  </h3>
                  <ul className="gift">
                    <li>
                      <div className="img">
                        <img
                          src={imgUrl + '/img/event/20210317/gift_img1.png'}
                          alt="신간도서"
                        />
                      </div>
                      <p>
                        <span>[괴롭히지 말아요, 나가토로 양]</span>
                        1~9권 1Set (1명)
                      </p>
                    </li>
                    <li>
                      <div className="img">
                        <img
                          src={imgUrl + '/img/event/20210317/gift_img5.png'}
                          alt="신간도서"
                        />
                      </div>
                      <p>
                        <span>[불멸의 그대에게]</span>
                        1~14권 1Set (1명)
                      </p>
                    </li>
                    <li>
                      <div className="img">
                        <img
                          src={imgUrl + '/img/event/20210317/gift_img2.png'}
                          alt="신작주제곡"
                        />
                      </div>
                      <p>
                        <span>[요란 THE PRINCESS OF SNOW AND BLOOD]</span>
                        주제곡 CD -Song.RAISE A SUILEN- (3명)
                      </p>
                    </li>
                    <li>
                      <div className="img">
                        <img
                          src={imgUrl + '/img/event/20210317/gift_img3.png'}
                          alt="컬처랜드"
                        />
                      </div>
                      <p>
                        <span>[컬처랜드]</span>
                        문화상품권 1만원 (5명)
                      </p>
                    </li>
                    <li>
                      <div className="img">
                        <img
                          src={imgUrl + '/img/event/20210317/gift_img4.png'}
                          alt="ANI+"
                        />
                      </div>
                      <p>
                        <span>[ANI+]</span>
                        포인트 1만원 (5명)
                      </p>
                    </li>
                  </ul>
                  <dl className="notice">
                    <dt>
                      <img
                        src={imgUrl + '/img/event/20210317/gift_notice.png'}
                        alt="NOTICE"
                      />
                    </dt>
                    <dd>
                      <p>
                        이벤트 상품 여부에 따라 당첨자 한정으로 &lt;이름,
                        연락처, 주소&gt; 확인이 필요합니다.
                      </p>
                      <p>
                        주제곡 음반 CD 경품은 음반 발매일 이후 배송이
                        가능합니다.
                      </p>
                      <p>
                        ANI+ 포인트는 지급 이후 1개월 동안 사용 가능하며, 이후
                        자동 소멸됩니다.
                      </p>
                      <p>당첨 상품 中 기프티콘은 LMS 문자로 발송됩니다.</p>
                    </dd>
                  </dl>
                </div>

                <div className="att_wrap att1" id="newList">
                  <h2 className="line_up">
                    애니플러스 2분기 신작 라인업
                    <p>
                      “#즐거움과 #덕력을 높일 수 있는 다양한 신작 어트랙션!”
                    </p>
                  </h2>

                  <h3 className="tit">
                    <p>Attraction1</p>
                    로맨스
                  </h3>
                  <Event202104_contentList eventCode={1} />
                </div>

                <div className="att_wrap att2">
                  <h3 className="tit">
                    <p>Attraction2</p>
                    SF
                  </h3>
                  <Event202104_contentList eventCode={2} />
                </div>

                <div className="att_wrap att3">
                  <h3 className="tit">
                    <p>Attraction3</p>
                    판타지
                  </h3>
                  <Event202104_contentList eventCode={3} />
                </div>

                <div className="att_wrap att4">
                  <h3 className="tit">
                    <p>Attraction4</p>
                    일상
                  </h3>
                  <Event202104_contentList eventCode={4} />
                </div>

                <div className="att_wrap att5">
                  <h3 className="tit">
                    <p>Attraction5</p>
                    액션
                  </h3>
                  <Event202104_contentList eventCode={5} />
                </div>
                <div className="btn_wrap" id="timetable">
                  <button
                    type="button"
                    className="btn_timeTbl"
                    onClick={this._timeTable}
                  >
                    신작 LIVE / TV 편성표 보기{' '}
                    <img src={imgUrl + '/img/event/20210317/arrow.png'} />
                  </button>
                </div>

                <div className="rules_wrap" id="rules">
                  <h3 className="tit">
                    애니플러스 2분기 신작 관람 수칙!
                    <p>
                      애니플러스 2분기 신작을 즐겁게 관람하는 방법!
                      <small>
                        (PC 와 앱에서도 무제한 이용이 가능하다는 것은 안.비.밀!){' '}
                      </small>
                    </p>
                  </h3>
                  <ul className="chapter">
                    <li>
                      <h4>CHAPTER.1</h4>
                      <p>
                        애니플러스 홈페이지
                        <br />
                        로그인 하기
                      </p>
                    </li>
                    <li>
                      <h4>CHAPTER.2</h4>
                      <p>
                        30일 무료 체험
                        <br />
                        프리페스권 발급하러 가기
                      </p>
                      <button
                        type="button"
                        className="btn_go"
                        onClick={this._pass}
                      >
                        바로가기
                      </button>
                    </li>
                    <li>
                      <h4>CHAPTER.3</h4>
                      <p>
                        2분기 실시간 LIVE 감상과
                        <br />
                        VOD 서비스 혜택을
                        <br />
                        플렉스 하자~!
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="comment"></div>
          </Fragment>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202104_newContent));
